import React, { useEffect, createElement } from 'react';
export function ApplicationForm() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.peptidescienceinstitute.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full max-w-3xl mx-auto relative" data-id="element-1">
      {/* Cyan glow behind the form */}
      <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
      boxShadow: '0 0 60px rgba(0, 240, 255, 0.07), 0 0 120px rgba(0, 240, 255, 0.03)'
    }} data-id="element-2"></div>

      {/* Container with subtle cyan border */}
      <div className="relative rounded-xl border border-[#00F0FF]/10 overflow-visible bg-[#111111]/50 backdrop-blur-sm" data-id="element-3">
        {/* Cyan top accent line */}
        <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00F0FF]/20 to-transparent" data-id="element-4"></div>

        <iframe src="https://link.peptidescienceinstitute.com/widget/survey/rciRJDLJyMYvGJZNfF0b" style={{
        border: 'none',
        width: '100%',
        minHeight: '800px',
        overflow: 'visible'
      }} scrolling="no" id="rciRJDLJyMYvGJZNfF0b" title="Application Survey" data-id="element-5" />

        {/* Cyan bottom accent line */}
        <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00F0FF]/15 to-transparent" data-id="element-6"></div>
      </div>
    </div>;
}